function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s"
    },
    width: "203px",
    height: "203px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 1,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.8519003931847968s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.8519003931847968s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.82131509385323,59.54544226058628)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.714285714285715)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.9285714285714286,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7863695937090431s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7863695937090431s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.71677564089214,67.20029261429666)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.8571428571428571,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.7208387942332896s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.7208387942332896s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.895460547038915,71.44841406800012)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(77.14285714285715)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.7857142857142857,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.655307994757536s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.655307994757536s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.104539452961085,71.44841406800012)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.7142857142857143,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5897771952817824s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5897771952817824s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.28322435910786,67.20029261429666)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(128.57142857142856)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.6428571428571429,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5242463958060288s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5242463958060288s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.17868490614678,59.545442260586285)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.2857142857143)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.5714285714285714,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.4587155963302752s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.4587155963302752s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28,50)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.5,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.39318479685452157s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.39318479685452157s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.178684906146778,40.45455773941372)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.42857142857142855,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.327653997378768s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.327653997378768s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.28322435910786,32.79970738570334)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(231.42857142857142)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.35714285714285715,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.2621231979030144s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.2621231979030144s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.10453945296108,28.55158593199988)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.1428571428571)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.2857142857142857,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.19659239842726078s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.19659239842726078s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.895460547038894,28.551585931999874)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(282.85714285714283)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.21428571428571427,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.1310615989515072s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.1310615989515072s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.71677564089214,32.79970738570334)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.5714285714286)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.14285714285714285,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.0655307994757536s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.0655307994757536s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.82131509385323,40.45455773941374)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(334.2857142857144)",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#fe6502",
    fillOpacity: 0.07142857142857142,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "1.31 1.31;1 1",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "0.9174311926605504s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.def850527205fbb51060486a3dae1f6c.svg";
export { ForwardRef as ReactComponent };